import { render, staticRenderFns } from "./DetailHasilLatihanSiswa.vue?vue&type=template&id=4b6e1d03"
import script from "./DetailHasilLatihanSiswa.vue?vue&type=script&lang=js"
export * from "./DetailHasilLatihanSiswa.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilLatihanSiswa.vue?vue&type=style&index=0&id=4b6e1d03&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports